import type { EnrollCourse400Result } from './enrollCourse400Result';

export type EnrollCourse400 = {
  /** 에러 코드 */
  errorCode: string;
  /** 실패 사유 */
  reason: string;
  result: EnrollCourse400Result;
};
